export default {
  CREATE_PRODUCTCATEGORIES (state, item) {
    state.productcategories.unshift(item)
  },

  SET_PRODUCTCATEGORIES (state, productcategories) {
    state.productcategories = productcategories
  },

  UPDATE_PRODUCTCATEGORIES (state, productcategory) {
    const productcategoryIndex = state.productcategories.findIndex((p) => p.id === productcategory.id)
    Object.assign(state.productcategories[productcategoryIndex], productcategory)
  }
}
